var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',_vm._l((_vm.count),function(n){return _c('BookingCardSkeletonLoader',{key:("booking-card-list-item__skeleton-loader-" + n)})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }